import React, { Component } from "react";
import { ModalHeader, ModalBody, Button } from "reactstrap";
import { connect } from "react-redux";
import * as actions from "../../stores/actions/index";
import { translate } from "react-i18next";

class LogoutModal extends Component {
  onSubmit = (e) => {
    this.props.logout();
    this.props.toggleModal();
  };

  render() {
    const { toggleModal, t } = this.props;
    return (
      <React.Fragment>
        {/* <form className="mb-3" name="formAssignUser" onSubmit={this.onSubmit}> */}
        <ModalHeader toggle={toggleModal}>
          {t("dashboard.areYouSure?")}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              style={{
                marginRight: "10px",
              }}
              color="info"
              type="submit"
              onClick={this.onSubmit}
            >
              {t("dashboard.logOut")}
            </Button>
            <Button color="secondary" type="button" onClick={toggleModal}>
              {t("dashboard.cancel")}
            </Button>
          </div>
        </ModalBody>
        {/* </form> */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.auth.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    getUserMetaStart: () => dispatch(actions.getUserMetaStart()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(LogoutModal));
